/**
 * Region pack registry + active-pack resolution.
 *
 * Wave B.1 (UK launch). The active pack is currently a module-level
 * variable that defaults to UK. Future: hydrate from `org.country`
 * via the Brain context (useBrain) so a US-anchored org gets the US
 * pack automatically. Until then, dev callers can call
 * `setActiveRegion('us')` for visual QA.
 */
import { UK_REGION } from './uk';
import { US_REGION } from './us';
import type { RegionCode, RegionPack } from './types';

export type { RegionCode, RegionPack, RegionTerms, RegionUnits, PhaseDefinition } from './types';
export { UK_REGION } from './uk';
export { US_REGION } from './us';

const REGIONS: Record<RegionCode, RegionPack> = {
  uk: UK_REGION,
  us: US_REGION,
};

let active: RegionPack = UK_REGION;

/** Override the active region. Call this once at app boot from
 *  whichever surface knows the org's country. */
export function setActiveRegion(code: RegionCode): void {
  const next = REGIONS[code];
  if (next) active = next;
}

/** Currently-active pack. Use the `useRegion()` hook from
 *  `useRegion.ts` to subscribe to changes; this is the imperative
 *  read for non-component code (validators, AI prompts). */
export function getActiveRegion(): RegionPack {
  return active;
}

/** Pick a pack by code without changing the active state. */
export function getRegion(code: RegionCode): RegionPack {
  return REGIONS[code] ?? UK_REGION;
}
